module.exports = __webpack_public_path__ + "static/media/s-loader.d926edaa.gif";